import React from 'react'
import { Link } from 'react-router-dom'
import ReadyToWork from './ReadyToWork';
import categoryList from './Categories';

export const Footer = () => {
  const facebookShareUrl = `https://www.facebook.com/Lurantech-107968334690860`;
  const linkedinShareUrl = `https://www.linkedin.com/company/lurantech`;
  const twitterShareUrl = `https://x.com/lurantech`;

  return (
    <>
      <ReadyToWork />
      <div className='footer-container'>
        <div className="row g-0">
          <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
          <div className="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
            <div className="row g-0">
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                <img src='/images/footer/footer-logo.svg' alt="lurantech-logo" />
              </div>
              <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              </div>
            </div>
            <div className="row g-0">
              <div className="col-6 col-sm-4 col-md-4 col-lg-3 col-xl-3">
                <div className='footer-title-link'><Link to='/'>Lurantech</Link></div>
                <div className='footer-sub-link'><Link to='/about-us'>Company Profile</Link></div>
                <div className='footer-sub-link'><Link to='/service'>What we do ?</Link></div>
                <div className='footer-sub-link'><Link to='/blogs'>Explore our Expertise</Link></div>
                <div className='footer-sub-link'><Link to='/contact-us'>Get in touch</Link></div>
              </div>
              <div className="col-6 col-sm-4 col-md-4 col-lg-3 col-xl-3">
                <div className='footer-title-link'><Link to='/blogs'>Blogs</Link></div>
                {Object.values(categoryList).map((category, index) => (
                  <div key={`category-footer-${index}`} className='footer-sub-link'>
                    <Link to={"/category/"+category.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9-]/g, '').toLowerCase()}>{category}</Link>
                  </div>
                ))}
              </div>
              <div className="col-6 col-sm-4 col-md-4 col-lg-3 col-xl-3">
              </div>
              <div className="col-6 col-sm-4 col-md-4 col-lg-3 col-xl-3">
                <Link to=''>
                  <div className='footer-title-link'>Follow us</div>
                </Link>
                <div className='footer-social-logo'>
                  <a target="_blank" rel="noreferrer" href={linkedinShareUrl}>
                    <img src='/images/footer/linkedin-logo.svg' alt="linkedin-logo" width={48} height={48}/>
                  </a>
                  <a target="_blank" rel="noreferrer" href={twitterShareUrl}>
                    <img src='/images/footer/x-logo.svg' alt="x-logo" width={48} height={48} />
                  </a>
                  <a target="_blank" rel="noreferrer" href={facebookShareUrl}>
                    <img src='/images/footer/fb-logo.svg' alt="facebook-logo" width={48} height={48}/>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
        </div>
        <div className='copyright-con'>
          Copyright © 2025 Lurantech. All rights reserved.
        </div>
      </div>
    </>
  )
}
